var exports = {
  "p": "xa15a2ab7--5324d6--agent-proofs-title",
  "l": "xa15a2ab7--5324d6--agent-reviews-title",
};

module.exports = exports;
